import { Component, input } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'lib-loading',
  imports: [TranslocoModule],
  templateUrl: './loading.html',
  styleUrl: './loading.css',
})
export class Loading<T> {
  data = input.required<T>();
  title = input<string>();
}
